export default "__VITE_ASSET__Dpo45uAu__"